module.exports = __webpack_public_path__ + "img/image_1.942bc7d6.png";